export default __webpack_public_path__ + "static/media/Nina_Heir_AHV_In_Moms_We_Trust.7492ed59.jpg";